import { useLocation } from '@tanstack/react-router';
import { getLocale, locales, localizeHref, type Locale } from '../paraglide/runtime';
import { isTranslated } from './localeHead';

export interface LanguageLink {
  locale: Locale;
  href: string;
  current: boolean;
}

/**
 * This page in every language it exists in, or null on an untranslated page.
 *
 * Every switcher renders these as plain anchors, never router links: the router
 * writes every href in the current locale, and a full document load is what
 * binds the new locale on the server. Nothing redirects on browser language or
 * location (see scripts/i18nConfig.ts).
 */
export const useLanguageLinks = (): LanguageLink[] | null => {
  // The router's location is the English path; the URL bar shows the localized one.
  const { pathname } = useLocation();
  if (!isTranslated(pathname)) return null;
  const current = getLocale();
  return locales.map((locale) => ({
    locale,
    href: localizeHref(pathname, { locale }),
    current: locale === current,
  }));
};
